import React, { useEffect, useState } from "react";
import { ModalCrosSvg } from "../../../images/Svgs";
import { toast } from "react-toastify";
import { AddLegalIformation } from "../../../API/LegalInfo";
const intintian = {
  type: "",
  description: "",
  is_active: 1,
};

const AddLegalInfo = ({ onModalClose, editInfo }) => {
  const [legalInfo, setLegalInfo] = useState(intintian);
  const [error, setError] = useState({
    type: "",
    description: "",
    is_active: "",
    legal_id: "",
  });

  useEffect(() => {
    if (Object.keys(editInfo).length > 0) {
      setLegalInfo((prevData) => ({
        ...prevData,
        ...editInfo,
        is_active: editInfo.is_active ? 1 : 0,
      }));
    }
  }, [editInfo]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "is_active") {
      setLegalInfo({ ...legalInfo, [name]: Number(value) });
    } else {
      setLegalInfo({ ...legalInfo, [name]: value });
    }
    setError({ ...error, [name]: "" });
  };

  // Validate form inputs
  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // Name validation
    if (!legalInfo.type) {
      errors.type = "Type is required.";
      isValid = false;
    }
    // Role validation
    if (!legalInfo.description) {
      errors.description = "Description is required.";
      isValid = false;
    }
    // Status validation
    if (legalInfo.is_active === "") {
      errors.is_active = "Status is required.";
      isValid = false;
    }
    setError(errors);
    return isValid;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        let payload = legalInfo;
        if (editInfo?.id) {
            payload.legal_id =editInfo?.id;
          }
        const response = await AddLegalIformation(payload);
        if (response?.status) {
          toast.success(response.message || "success !");
          onModalClose(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error during login request:", error); // Handle any other errors
      }
    } else {
      console.log("Form has errors.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal fade show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {Object.keys(editInfo).length > 0
                  ? "Update Legal Information"
                  : "Add Legal Information"}
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => onModalClose(false)}
              >
                <ModalCrosSvg />
              </button>
            </div>
            <div className="modal-body">
              <div className="event_form">
                <form id="eventForm" onSubmit={(e) => handleSubmit(e)}>
                  {/* Event Title */}
                  <div className="col">
                    <label className="form-label d-flex align-items-center">
                      Type
                    </label>
                    <select
                      className="form-select"
                      name="type"
                      value={legalInfo?.type}
                      onChange={(e)=>handleChange(e)}
                      disabled={editInfo?.id}
                    >
                      <option value="">Select Type</option>
                      <option value="privacyPolicies">Privacy Policies</option>
                      <option value="termsCondition">Terms & Conditions</option>
                    </select>
                    {error.type && (
                      <div className="text-danger">{error.type}</div>
                    )}
                  </div>
                  <textarea
                    className="form-control mt-3 inter font-12"
                    id="exampleFormControlTextarea1"
                    rows="4"
                    placeholder="Add Descriptions"
                    name="description"
                    value={legalInfo?.description}
                    onChange={(e) => handleChange(e)}
                  ></textarea>
                  {error.description && (
                    <div className="text-danger">{error.description}</div>
                  )}

                  <div className="col">
                    <label className="form-label d-flex align-items-center">
                      Status
                    </label>
                    <select
                      className="form-select"
                      name="is_active"
                      value={legalInfo?.is_active}
                      onChange={handleChange}
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Deactive</option>
                    </select>
                    {error.is_active && (
                      <div className="text-danger">{error.is_active}</div>
                    )}
                  </div>
                  <br />
                  {/* Buttons */}
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => onModalClose(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-dark">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLegalInfo;
